import { lazy, Suspense, useRef, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';
const AssistantPanel = lazy(() => import('./AssistantPanel'));

export default function SmartChatbot() {
  const [open, setOpen] = useState(false);
  const [version, setVersion] = useState(0);
  const { i18n } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const lang = i18n.language.split('-')[0];
  const t = { open: lang === 'fr' ? 'Ouvrir DEM Assistant' : lang === 'es' ? 'Abrir DEM Assistant' : 'Open DEM Assistant' };
  const close = () => { setOpen(false); requestAnimationFrame(() => buttonRef.current?.focus()); };
  return <><button ref={buttonRef} onClick={() => { setVersion(v => v + 1); setOpen(true); }} aria-label={t.open} aria-expanded={open} className={`fixed bottom-24 right-6 z-[90] flex h-14 items-center gap-3 rounded-full border border-[#d7c1a9]/30 bg-[#262822] px-4 text-[#f4ece2] shadow-xl transition-transform hover:scale-105 ${open ? 'invisible' : ''}`}><MessageSquare size={21} /><span className="hidden font-oswald text-xs uppercase tracking-[.15em] sm:inline">DEM Assistant</span></button><AnimatePresence>{open && <Suspense fallback={<span role="status" className="fixed bottom-40 right-6 z-[90] bg-white p-4">…</span>}><AssistantPanel key={version} close={close} retry={() => setVersion(v => v + 1)} /></Suspense>}</AnimatePresence></>;
}

